import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { HiSparkles } from 'react-icons/hi';
import { DashboardStatus, getDashboardStatusColor, getDashboardStatusLabel } from '../../constants/integrationTypes';

interface DashboardStatusBadgeProps {
  status?: string;
  label?: string;
  withRiskHighlight?: boolean;
  className?: string;
  badgeClassName?: string;
  showAiIcon?: boolean;
  dataOnboarding?: string;
  dataOnboardingEntityName?: string;
  dataOnboardingEntityId?: string;
}

const DashboardStatusBadge: React.FC<DashboardStatusBadgeProps> = ({
  status,
  label,
  withRiskHighlight = false,
  className = '',
  badgeClassName = '',
  showAiIcon = true,
  dataOnboarding,
  dataOnboardingEntityName,
  dataOnboardingEntityId
}) => {
  const normalizedStatus = (status || '').toLowerCase();
  const isAtRisk = normalizedStatus === DashboardStatus.AT_RISK;

  if (!status) {
    return null;
  }

  const displayLabel = label || getDashboardStatusLabel(status || '');
  const statusColor = getDashboardStatusColor(status || '');

  return (
    <div className={`flex items-center gap-1 relative ${className}`}>
      <span
        data-onboarding={dataOnboarding}
        data-onboarding-entity-name={dataOnboardingEntityName}
        data-onboarding-entity-id={dataOnboardingEntityId}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-lg whitespace-nowrap text-white ${statusColor} ${
          isAtRisk && withRiskHighlight
            ? "border border-red-500/20 hover:border-red-400/40 shadow-md hover:shadow-lg transform hover:scale-105 cursor-pointer transition-all duration-200 relative font-medium after:absolute after:-inset-0 after:rounded-lg after:border after:border-red-400/40 after:opacity-0 group-hover:after:opacity-100 group-hover:after:animate-[ping_1s_ease-in-out_2] after:pointer-events-none after:z-[-1]"
            : ""
        } ${badgeClassName}`}
      >
        {isAtRisk && <FiAlertTriangle className="w-3 h-3 flex-shrink-0" />}
        {displayLabel}
      </span>
      {isAtRisk && showAiIcon && (
        <HiSparkles
          title="AI Help"
          className="w-4 h-4 text-blue-500 hover:text-purple-500 cursor-pointer transition-all duration-200 drop-shadow-sm"
        />
      )}
    </div>
  );
};

export default DashboardStatusBadge;